module.exports = __webpack_public_path__ + "static/media/5.dc89e0c9.jpg";